import "./App.css";
import { Routes, Route, useNavigate } from "react-router-dom";
import "@assets/scss/theme.scss";
import { authRoutes, nonAuthRoutes } from "./routes/route-list";
import { AuthMiddleware } from "./routes";
import { Layout } from "@components/layout/layout";
import { PageNotFound } from "./components/404-page";
import "react-toastify/dist/ReactToastify.css";
import { STORAGE_KEY } from "./constants/constants";
import { useEffect, useState } from "react";
import ResetPassword from "./pages/reset-password/ui";
import UserProfile from "./pages/profile/ui";

function App() {
  const navigate = useNavigate();
  const [filteredAuthRoutes, setFilteredAuthRoutes] = useState([]);

  useEffect(() => {
    const path = window.location.pathname;
    const token = localStorage.getItem(STORAGE_KEY.TOKEN);
    const loginState = localStorage.getItem(STORAGE_KEY.LOGIN_STATE);
    const userData = localStorage.getItem(STORAGE_KEY.USER);

    let loginResponse = null;
    try {
      loginResponse = userData ? JSON.parse(userData) : null;
    } catch (e) {
      console.error("Error parsing user data:", e);
    }

    if (
      !loginState &&
      !token &&
      !["/forgot-password", "/reset-password", "/login"].includes(path)
    ) {
      navigate("/login");
    } else if (token) {
      if (path === "/" && loginResponse) {
        navigate("/dashboard");
      }
    }

    const userPermissions = loginResponse?.permission_ids || [];

    let filteredRoutes = [];
    if (loginResponse?.type == 1) {
      filteredRoutes = authRoutes
    } else {
      filteredRoutes = authRoutes.filter(
        (route) => route.permission === true || userPermissions.includes(route.permission)
      );
    }

    setFilteredAuthRoutes(filteredRoutes);
  }, [navigate, authRoutes]);

  return (
    <div className="App">
      <Routes>
        {nonAuthRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={route.component}
            key={idx}
            exact={true}
          />
        ))}

        {filteredAuthRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <AuthMiddleware>
                <Layout>{route.component}</Layout>
              </AuthMiddleware>
            }
            key={idx}
            exact={true}
          />
        ))}

        <Route path="/set-password" element={<ResetPassword />} exact={true} />
        <Route path="/profile" element={<UserProfile />} exact={true} />

        <Route
          path="/app/*"
          element={
            <AuthMiddleware>
              <Layout>
                <PageNotFound />
              </Layout>
            </AuthMiddleware>
          }
        />

        <Route path="*" element={<PageNotFound />} exact={true} />
      </Routes>
    </div>
  );
}

export default App;